














import Vue from 'vue';
import { IProductStep } from '../../../common/interfaces/challenge.interface';

export default Vue.extend({
  name: `CompletePreparationStep`,
  props: {
    step: {
      required: true,
      type: Object as () => IProductStep,
    },
  },
});
